import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateCategoryTypeV3 = OpalApi<'UpdateCategoryTypeV3', 200>

export const updateCategoryType: UpdateCategoryTypeV3 = async (args = {}) => {
  const categoryTypeId = args.params?.path.category_type_id

  if (typeof categoryTypeId !== 'string') {
    throw new Error('Must supply a valid category_type_id.')
  }

  const url = new URL(
    `/loupe/v3/category_types/${categoryTypeId}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
